import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CarritocomprasComponent } from './pagina-externa/carritocompras/carritocompras.component';
import { DetalleComponent } from './pagina-externa/detalle/detalle.component';
import { InicioComponent } from './pagina-externa/inicio/inicio.component';
import { PaginaExternaComponent } from './pagina-externa/pagina-externa.component';
import { ProcesarPagoComponent } from './pagina-externa/procesar-pago/procesar-pago.component';
import { LoginAdminComponent } from './pagina-admin/login-admin/login-admin.component';
import { DashboardComponent } from './pagina-admin/dashboard/dashboard/dashboard.component';
import { BandejaPedidoComponent } from './pagina-admin/dashboard/bandeja-pedido/bandeja-pedido.component';
import { RegistrarComponent } from './pagina-externa/usuario/registrar/registrar.component';
import { MiCuentaComponent } from './pagina-externa/usuario/mi-cuenta/mi-cuenta.component';
import { DatosPersonalesComponent } from './pagina-externa/usuario/mi-cuenta/datos-personales/datos-personales.component';
import { MisPedidosComponent } from './pagina-externa/usuario/mi-cuenta/mis-pedidos/mis-pedidos.component';
import { RecuperarContrasenaComponent } from './pagina-externa/usuario/recuperar-contrasena/recuperar-contrasena.component';
import { RecuperarContrasenaTokenComponent } from './pagina-externa/usuario/recuperar-contrasena-token/recuperar-contrasena-token.component';
import { SourvenirComponent } from './pagina-externa/sourvenir/sourvenir.component';
import { DetalleSourvenirComponent } from './pagina-externa/detalle-sourvenir/detalle-sourvenir.component';

//mantenimiento
import { MantCategoriaComponent } from './pagina-admin/dashboard/gestionLibros/mant-categoria/mant-categoria.component';
import { MantAniosComponent } from './pagina-admin/dashboard/gestionLibros/mant-anios/mant-anios.component';
import { MantAutorComponent } from './pagina-admin/dashboard/gestionLibros/mant-autor/mant-autor.component';
import { MantBookComponent } from './pagina-admin/dashboard/gestionLibros/mant-book/mant-book.component';
import { MatInventarioComponent } from './pagina-admin/dashboard/gestionLibros/mat-inventario/mat-inventario.component';

import { MantGruposComponent } from './pagina-admin/dashboard/gestionProductos/mant-grupos/mant-grupos.component';
import { MantInventarioProdComponent } from './pagina-admin/dashboard/gestionProductos/mant-inventario-prod/mant-inventario-prod.component';
import { MantProductoComponent } from './pagina-admin/dashboard/gestionProductos/mant-producto/mant-producto.component';
import { MantSubmenuComponent } from './pagina-admin/dashboard/gestionProductos/mant-submenu/mant-submenu.component';
import { MantTopicComponent } from './pagina-admin/dashboard/gestionProductos/mant-topic/mant-topic.component';
import { ConsultasComponent } from './pagina-externa/consultas/consultas.component';
import { NiubizComponent } from './pagina-externa/test/niubiz/niubiz.component';
import { ResulPagoNiubizComponent } from './pagina-externa/procesar-pago/resul-pago-niubiz/resul-pago-niubiz.component';
import { FilesComponent } from './pagina-externa/files/files.component';

// nlpr ini
import { FotografiaLayoutComponent } from './pagina-externa/fotografia-layout/fotografia-layout.component';
import { FotografiaPanelComponent } from './pagina-externa/fotografia-layout/fotografia-panel/fotografia-panel.component';
import { PortadaLayoutComponent } from './pagina-externa/portada-layout/portada-layout.component';
import { PortadaPanelComponent } from './pagina-externa/portada-layout/portada-panel/portada-panel.component';
import { FotografiaDetalleComponent } from './pagina-externa/fotografia-layout/fotografia-panel/fotografia-detalle/fotografia-detalle.component';
import { PortadaDetalleComponent } from './pagina-externa/portada-layout/portada-panel/portada-detalle/portada-detalle.component';
import { TerminosCondicionesComponent } from './pagina-externa/terminos-condiciones/terminos-condiciones.component';
import { TratamientoDatosComponent } from './pagina-externa/tratamiento-datos/tratamiento-datos.component';
// import { PoliticaPrivacidadComponent } from './pagina-externa/politica-privacidad/politica-privacidad.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { AuthGuard } from './guards/auth.guard';
// nlpr fin

const routes: Routes = [
  {
    path: '',
    component: PaginaExternaComponent,
    children: [
      {
        path: '',
        component: InicioComponent,
        data: {
          seo: {
            title:
              'Archivo Histórico del Diario Oficial El Peruano | Fotos de archivo | Portadas históricas | Fotos del Siglo XIX',
            description:
              'Fotografías y publicaciones del Archivo Histórico del diario Oficial El Peruano',
            og: true,
          },
        },
      },
      { path: 'test', component: NiubizComponent },
      { path: 'catalogo/:idTipoPublicacion', component: InicioComponent },
      { path: 'sourvenir/:idSourvenir', component: SourvenirComponent },
      { path: 'sourvenir/:idSourvenir/:idTema', component: SourvenirComponent },
      { path: 'files/:idImage', component: FilesComponent },

      { path: 'detalle/:idLibro', component: DetalleComponent },
      //daet ini
      { path: 'detalle/:idLibro/:nothing', component: DetalleComponent },
      {
        path: 'detalle/:idLibro/:nothing1/:nothing2',
        component: DetalleComponent,
      },
      { path: 'd/:idLibro', component: DetalleComponent },
      { path: 'd/:nothing/:idLibro', component: DetalleComponent },

      { path: 'dt/:nothing/:idLibro', component: FotografiaDetalleComponent },
      { path: 'dtp/:nothing/:idLibro', component: PortadaDetalleComponent },

      //daet fin
      { path: 'consultas', component: ConsultasComponent },
      //{path:'detalleSourvenir/:idSourvenirProducto',component: DetalleSourvenirComponent},
      { path: 'carrito', component: CarritocomprasComponent, canActivate: [AuthGuard] },
      { path: 'procesarpago', component: ProcesarPagoComponent, canActivate: [AuthGuard] },
      {
        path: 'respuestaprocesoniubiz/:transactionToken/:amount/:purchasenumber',
        component: ResulPagoNiubizComponent,
      },

      { path: 'registrar', component: RegistrarComponent },

      {
        path: 'mi-cuenta',
        component: MiCuentaComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: DatosPersonalesComponent },
          { path: 'mis-pedidos', component: MisPedidosComponent },
        ],
      },
      { path: 'terminos-condiciones', component: TerminosCondicionesComponent },
      { path: 'tratamiento-datos', component: TratamientoDatosComponent },
      // Ruta eliminada - Política de privacidad se accede desde PDF externo
      // { path: 'politica-privacidad', component: PoliticaPrivacidadComponent },
      { path: 'registrar', component: RegistrarComponent },
      { path: 'recuperar-contrasena', component: RecuperarContrasenaComponent },
      {
        path: 'recuperar-contrasena/:token',
        component: RecuperarContrasenaTokenComponent,
      },
      { path: '404', component: NotFoundComponent },
    ],
  },
  // nlpr ini
  {
    path: 'fotografias',
    component: FotografiaLayoutComponent,
    children: [
      { path: '', component: FotografiaPanelComponent },
      { path: 'dt/:idLibro', component: FotografiaDetalleComponent },
      { path: 'dt/:nothing/:idLibro', component: FotografiaDetalleComponent },
    ],
  },
  {
    path: 'fotografias/:idCate',
    component: FotografiaLayoutComponent,
    children: [
      { path: '', component: FotografiaPanelComponent },
      { path: 'dt/:idLibro', component: FotografiaDetalleComponent },
      { path: 'dt/:nothing/:idLibro', component: FotografiaDetalleComponent },
    ],
  },
  {
    path: 'fotografias/:idCate/:idSubCate',
    component: FotografiaLayoutComponent,
    children: [
      { path: '', component: FotografiaPanelComponent },
      { path: 'dt/:idLibro', component: FotografiaDetalleComponent },
      { path: 'dt/:nothing/:idLibro', component: FotografiaDetalleComponent },
    ],
  },
  {
    path: 'portadas',
    component: PortadaLayoutComponent,
    children: [
      { path: '', component: PortadaPanelComponent },
      { path: 'dtp/:idLibro', component: PortadaDetalleComponent },
      { path: 'dtp/:nothing/:idLibro', component: PortadaDetalleComponent },
    ],
  },
  {
    path: 'portadas/:idCate',
    component: PortadaLayoutComponent,
    children: [
      { path: '', component: PortadaPanelComponent },
      { path: 'dtp/:idLibro', component: PortadaDetalleComponent },
      { path: 'dtp/:nothing/:idLibro', component: PortadaDetalleComponent },
    ],
  },
  {
    path: 'portadas/:idCate/:idSubCate',
    component: PortadaLayoutComponent,
    children: [
      { path: '', component: PortadaPanelComponent },
      { path: 'dtp/:idLibro', component: PortadaDetalleComponent },
      { path: 'dtp/:nothing/:idLibro', component: PortadaDetalleComponent },
    ],
  },
  // nlpr fin
  { path: 'loginadmin', component: LoginAdminComponent },
  {
    path: 'dasboard',
    component: DashboardComponent,
    children: [
      { path: 'bandejapedidos', component: BandejaPedidoComponent },
      { path: 'mantCategoria', component: MantCategoriaComponent },
      { path: 'mantAnio', component: MantAniosComponent },
      { path: 'mantAutor', component: MantAutorComponent },
      { path: 'mantBook', component: MantBookComponent },
      { path: 'mantInventario', component: MatInventarioComponent },
      { path: 'mantGrupos', component: MantGruposComponent },
      { path: 'mantinventarioprod', component: MantInventarioProdComponent },
      { path: 'mantsubmenu', component: MantSubmenuComponent },
      { path: 'mantTopic', component: MantTopicComponent },
      { path: 'mantProducto', component: MantProductoComponent },
    ],
  },
  {
    path: '**',
    component: PaginaExternaComponent,
    pathMatch: 'full',
    children: [{ path: '', component: InicioComponent }],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
